import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueCookies from 'vue-cookies'
import isbot from 'isbot'
import { SUPPORTED_LOCALES, ES_LOCALE, EN_LOCALE, MX_LOCALE } from '@/constants/locales'
import { getCookie, saveLangPrefCookie, LANG_PREF_REGEX } from '@/helpers/cookies.helpers'
import { country } from '@/helpers/global.helpers'

Vue.use(VueI18n)
Vue.use(require('vue-cookies'))
Vue.use(VueCookies, { expire: '7d'})

const navigatorLanguage = (navigator.language || navigator.userLanguage).split('-')[0].toLowerCase()

function normalizeLocale(locale) {
	return SUPPORTED_LOCALES.includes(locale) ? locale : EN_LOCALE
}

function defaultLanguage() {
	return navigatorLanguage === ES_LOCALE ? (window.location.hostname.includes('opensalud.mx') ? MX_LOCALE : ES_LOCALE) : normalizeLocale(navigatorLanguage)
}

function getRawLocale() {
	// Get locale from URI
	let locale = window.location.pathname.split('/')[1]
	// If locale is not valid, get default locale
	if (!SUPPORTED_LOCALES.includes(locale)) {
		locale = defaultLanguage()
	}
	return locale
}

function normalizeLangpref(langpref) {
	if (!langpref) {
		return null
	} else {
		return langpref.match(LANG_PREF_REGEX) ? langpref.replace('%2F', '/') : null
	}
}

export function getCurrentLocaleOnInit() {
	const params = new Proxy(new URLSearchParams(window.location.search), {
		get: (searchParams, prop) => searchParams.get(prop)
	})
	const langPrefQueryParam = params.langpref ? params.langpref.match(LANG_PREF_REGEX) : null
	let langprefCookie = langPrefQueryParam ? `${langPrefQueryParam[1]}/${langPrefQueryParam[2]}` : normalizeLangpref(getCookie('langpref'))
	if (!langprefCookie) {
		langprefCookie = `${country}/${defaultLanguage()}`
	}
	saveLangPrefCookie(langprefCookie)
	return langprefCookie != null ? langprefCookie.split('/')[1] : defaultLanguage()
}

const i18n = new VueI18n({
	locale: isbot(navigator.userAgent) ? getRawLocale() : (getCurrentLocaleOnInit() || EN_LOCALE),
	fallbackLocale: ES_LOCALE
})

export const i18nLocale = i18n.locale
export function mergeLocaleMessage(locale, message) {
	i18n.mergeLocaleMessage(locale, message)
}

export default i18n


// WEBPACK FOOTER //
// ./src/plugins/i18n.js